// Case d'acceptation des conditions, à la création d'un compte (inscription,
// invitation d'équipe). La règle qui fait foi est CÔTÉ SERVEUR : cette case ne
// fait que recueillir l'accord ; sans elle, le serveur refuse le compte.
//
// Les liens s'ouvrent dans un nouvel onglet : les suivre dans l'onglet courant
// ferait perdre le formulaire à moitié rempli.
import { hrefFor } from '../router';

export function TermsConsent({ checked, onChange }: { checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <label className="terms-consent">
      <input className="zy-check" type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <span>
        J’accepte les{' '}
        <a href={hrefFor('/conditions')} target="_blank" rel="noopener noreferrer">
          conditions d’utilisation de la bêta
        </a>{' '}
        et j’ai pris connaissance de la{' '}
        <a href={hrefFor('/confidentialite')} target="_blank" rel="noopener noreferrer">
          politique de confidentialité
        </a>
        .
      </span>
    </label>
  );
}
